import { useState, useEffect, useContext } from "react";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Dropdown } from "primereact/dropdown";
import { delimitationService } from "../services/DelimitationService";
import { changeLang } from "../componets/Language/ChangeLang";
import AddDermacation from "../componets/AddDermacation";
import { DermacationLevels, permissionLookUp } from "../constants";
import { AppDB } from "../App";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import MoveDelimitations from "./delimitations/MoveDelimitations";
import { fetchRegistrationCentres } from "./ResultManagement/services/api";
import { ProgressSpinner } from "primereact/progressspinner";
import ScreenLoader from "../componets/ScreenLoader";
import { authenticationService } from "../services/AuthenticationService";

export const DelimitationManagement = () => {
	const [nodes, setNodes] = useState([]);
	const [selectedNodeKey, setSelectedNodeKey] = useState(null);
	const [dialogVisible, setDialogVisible] = useState(false);
	const [editMode, setEditMode] = useState(false);
	const [nodeName, setNodeName] = useState("");
	const [targetNode, setTargetNode] = useState(null);

	const [isLoading, setIsLoading] = useState(false);
	const dermacations = [
		{ name: "National Assembly Structure", id: 1 },
		{ name: "Local Government Structure", id: 2 }
	];

	const [selectedDemarcation, setSelectedDemarcation] = useState(1);
	const [moveDermacation, setmoveDermacation] = useState(false);
	const [dermacationForm, setdermacationForm] = useState({
		districtID: "",
		districtName: "",
		constituencyID: "",
		constituencyName: "",
		votingDistrictID: "",
		parentID: null,
		parentCode: "",
		votingDistrictName: "",
		registrationCentreName: "",
		registrationCentreID: null,
		registrationCenterNAID: null,
		registrationCenterLGID: null,
		description: "",
		code: "",
		no: null,
		level: 0,
		id: null,
		villageName: "",
		RegistrationCentreModel: null,
		parentRegistrationCentreID: null
	});

	const { permission, toast } = useContext(AppDB);
	const fetchDistricts = (id) => {
		setIsLoading(true);
		if (id === 1) {
			delimitationService
				.getDistricts()
				.then((resp) => {
					setIsLoading(false);
					const districts = (Array.isArray(resp) ? resp : []).map((d) => ({
						key: `district-${d.id}`,
						data: { ...d, name: `${d.code} - ${d.name}`, level: 1 },
						children: [],
						leaf: false
					}));
					setNodes(districts);
				})
				.catch(() => setNodes([]));
		} else {
			delimitationService
				.getLocalDistricts()
				.then((resp) => {
					setIsLoading(false);
					const districts = (Array.isArray(resp) ? resp : []).map((d) => ({
						key: `Local District-${d.id}`,
						data: { ...d, name: `${d.code} - ${d.name}`, level: 1, code: d.code },
						children: [],
						leaf: false
					}));
					setNodes(districts);
				})
				.catch(() => setNodes([]));
		}
	};

	const fetchConstituencies = async (districtNode) => {
		setdermacationForm((prev) => ({
			...prev,
			districtID: districtNode?.data?.id,
			districtName: districtNode.data.name
		}));

		if (!districtNode?.data) return [];
		setIsLoading(true);
		try {
			const resp = await delimitationService.getConstituenciesByDistrict(districtNode.data.id);
			setIsLoading(false);
			return (Array.isArray(resp) ? resp : []).map((c) => ({
				key: `constituency-${c.id}`,
				data: { ...c, name: `${c.code} - ${c.name}`, level: 2, code: c.code },
				children: [],
				leaf: false
			}));
		} catch (err) {
			setIsLoading(false);
			console.error("Error fetching constituencies:", err);
			return [];
		}
	};

	const fetchCouncils = async (districtNode) => {
		setdermacationForm((prev) => ({
			...prev,
			districtID: districtNode?.data?.id,
			districtName: districtNode.data.name
		}));

		if (!districtNode?.data) return [];
		setIsLoading(true);

		try {
			const resp = await delimitationService.getCouncilsByDistrict(districtNode.data.id);
			setIsLoading(false);
			return (Array.isArray(resp) ? resp : []).map((c) => ({
				key: `Councils-${c.id}`,
				data: { ...c, name: `${c.code} - ${c.name}`, level: 2, code: c.code },
				children: [],
				leaf: false
			}));
		} catch (err) {
			setIsLoading(false);
			console.error("Error fetching councils:", err);
			return [];
		}
	};

	const fetchVotingDistricts = async (constituencyNode) => {
		setdermacationForm((prev) => ({
			...prev,
			constituencyID: constituencyNode?.data?.id,
			constituencyName: constituencyNode.data.name
		}));

		if (!constituencyNode?.data) return [];
		setIsLoading(true);
		try {
			const resp = await delimitationService.getPollingDivisionsByConstituency(constituencyNode.data.id);
			setIsLoading(false);
			return (Array.isArray(resp) ? resp : []).map((v) => ({
				key: `votingdistrict-${v.id}`,
				data: { ...v, name: `${v.code} - ${v.name}`, level: 3, code: v.code },
				children: [],
				leaf: false
			}));
		} catch (err) {
			setIsLoading(false);
			console.error("Error fetching voting districts:", err);
			return [];
		}
	};

	const fetchElectoralDivision = async (constituencyNode) => {
		setdermacationForm((prev) => ({
			...prev,
			constituencyID: constituencyNode?.data?.id,
			constituencyName: constituencyNode.data.name
		}));

		if (!constituencyNode?.data) return [];
		setIsLoading(true);
		try {
			const resp = await delimitationService.GetLocalVotingDistrictsByCouncilIdAsync(constituencyNode.data.id);
			setIsLoading(false);
			return (Array.isArray(resp) ? resp : []).map((v) => ({
				key: `Electoral Division-${v.id}`,
				data: { ...v, name: `${v.code} - ${v.name}`, level: 3, code: v.code },
				children: [],
				leaf: false
			}));
		} catch (err) {
			setIsLoading(false);
			console.error("Error fetching voting districts:", err);
			return [];
		}
	};
	const fetchVotingStations = async (votingDistrictNode) => {
		setdermacationForm((prev) => ({
			...prev,
			votingDistrictID: votingDistrictNode?.data?.id,
			votingDistrictName: votingDistrictNode.data.name
		}));

		if (!votingDistrictNode?.data) return [];
		setIsLoading(true);
		try {
			const resp = await delimitationService.getRegistrationCentresByPollingDivision(votingDistrictNode.data.id);
			setIsLoading(false);
			return (Array.isArray(resp) ? resp : []).map((s) => ({
				key: `votingstation-${s.id}`,
				data: { ...s, name: `${s.code} - ${s.name}`, level: 4, code: s.code, fullName: s.name },
				children: [],
				leaf: false
			}));
		} catch (err) {
			console.error("Error fetching voting stations:", err);
			return [];
		}
	};

	const fetchPollingCentre = async (votingDistrictNode) => {
		setdermacationForm((prev) => ({
			...prev,
			votingDistrictID: votingDistrictNode?.data?.id,
			votingDistrictName: votingDistrictNode.data.name
		}));

		if (!votingDistrictNode?.data) return [];
		setIsLoading(true);
		try {
			const resp = await delimitationService.GetLocalVotingStationByElectorDivisionIDAsync(votingDistrictNode.data.id);
			setIsLoading(false);
			return (Array.isArray(resp) ? resp : []).map((s) => ({
				key: `votingstation-${s.id}`,
				data: { ...s, name: `${s.code} - ${s.name}`, level: 4, code: s.code, fullName: s.name },
				children: [],
				leaf: false
			}));
		} catch (err) {
			setIsLoading(false);
			console.error("Error fetching voting stations:", err);
			return [];
		}
	};

	const fetchVillages = async (registrationCentreNode) => {
		setdermacationForm((prev) => ({
			...prev,
			registrationCentreName: registrationCentreNode.data.name
		}));

		if (!registrationCentreNode?.data) return [];
		setIsLoading(true);
		try {
			const resp = await delimitationService.getVillagesByRegistrationCentre(registrationCentreNode.data.id, true);
			setIsLoading(false);
			return (Array.isArray(resp) ? resp : []).map((v) => ({
				key: `village-${v.id}`,
				data: { ...v, name: `${v.code} - ${v.name}`, level: 5, code: v.code, fullName: v.name },
				children: [],
				leaf: true
			}));
		} catch (err) {
			setIsLoading(false);
			console.error("Error fetching villages:", err);
			return [];
		}
	};

	const fetchPollingStation = async (registrationCentreNode) => {
		if (!registrationCentreNode?.data) return [];
		setIsLoading(true);
		try {
			const resp = await delimitationService.getLocalVillagesByRegistrationCentre(registrationCentreNode.data.id, true);
			setIsLoading(false);
			return (Array.isArray(resp) ? resp : []).map((v) => ({
				key: `village-${v.id}`,
				data: { ...v, name: `${v.code} - ${v.name}`, level: 5, code: v.code, fullName: v.name },
				children: [],
				leaf: true
			}));
		} catch (err) {
			setIsLoading(false);
			console.error("Error fetching villages:", err);
			return [];
		}
	};

	const findParentChain = (key, tree, chain = []) => {
		for (let node of tree) {
			if (node.key === key) return chain;
			if (node.children && node.children.length > 0) {
				const found = findParentChain(key, node.children, [...chain, node]);
				if (found) return found;
			}
		}
		return null;
	};

	const handleSelectNode = (node) => {
		if (!node?.data) return;

		let newForm = { ...dermacationForm, level: node.data.level };

		if (node.data.level === 1) {
			newForm.districtID = node.data.id;
			newForm.districtName = node.data.name;
		} else {
			const parents = findParentChain(node.key, nodes) || [];

			parents.forEach((p) => {
				switch (p.data.level) {
					case 1:
						newForm.districtID = p.data.id;
						newForm.districtName = p.data.name;
						break;
					case 2:
						newForm.constituencyID = p.data.id;
						newForm.constituencyName = p.data.name;
						break;
					case 3:
						newForm.votingDistrictID = p.data.id;
						newForm.votingDistrictName = p.data.name;
						break;
					case 4:
						newForm.registrationCentreName = node.data.name;
						if (selectedDemarcation?.id === 1) {
							newForm.registrationCenterNAID = p.data.id || null;
						} else if (selectedDemarcation?.id === 2) {
							newForm.registrationCenterLGID = p.data.id || null;
						}
						break;
				}
			});

			switch (node.data.level) {
				case 3:
					newForm.votingDistrictID = node.data.id;
					newForm.votingDistrictName = node.data.name;
					newForm.registrationCenterNAID = null;
					newForm.status = node.data.status;
					break;
				case 5:
					const regParent = parents.find((p) => p.data.level === 4);
					if (regParent) {
						newForm.registrationCentreName = regParent.data.name;
						if (selectedDemarcation?.id === 1) {
							newForm.registrationCenterNAID = regParent.data.registrationCenterNAID || null;
						} else if (selectedDemarcation?.id === 2) {
							newForm.registrationCenterLGID = regParent.data.registrationCenterLGID || null;
						}
					}
					break;
			}
		}

		setdermacationForm(newForm);
	};

	var userDelimitations = authenticationService.getUserDelimitation();
	const districts = userDelimitations.filter((x) => x.delimitationLevelID === 1 && x.districtID !== null);

	const allowedDistrictIds = new Set((districts || []).map((d) => d.districtID));
	const getDistrictIdForNode = (node) => {
		if (!node) return null;
		if (node.data?.level === DermacationLevels.Level1) return node.data.id;

		const parents = findParentChain(node.key, nodes) || [];
		const districtParent = parents.find((p) => p.data?.level === DermacationLevels.Level1);
		return districtParent?.data?.id ?? null;
	};

	const UpdateNodeChildren = async (id, level) => {
		var pollingDivisionID = null;
		var registrationCentreID = null;
		var votingDistrictID = null;
		const updateTree1 = (tree) =>
			tree.map((n) => {
				if (n.data.id === id && n.data.level === level) {
					pollingDivisionID = n.data.pollingDivisionID;
					registrationCentreID = n?.data?.registrationCentreID;
					votingDistrictID = n?.data?.votingDistrictID;
					return { ...n, children: [] };
				}
				if (n.children && n.children.length > 0) return { ...n, children: updateTree1(n.children) };
				return n;
			});

		updateTree1(nodes);

		const updateTree = async (tree) => {
			return Promise.all(
				tree.map(async (n) => {
					if (selectedDemarcation?.id === 1) {
						if (n.data.id === pollingDivisionID && n.data.level === 3) {
							const resp = await delimitationService.GetLocalVotingStationByElectorDivisionIDAsync(pollingDivisionID);
							const children = (Array.isArray(resp) ? resp : []).map((s) => ({
								key: `votingstation-${s.id}`,
								data: { ...s, name: `${s.code} - ${s.name}`, level: 4, code: s.code },
								children: [],
								leaf: false
							}));
							return { ...n, children };
						}

						if (n.data.id === registrationCentreID && n.data.level === 4) {
							const resp = await delimitationService.getVillagesByRegistrationCentre(registrationCentreID);
							const children = (Array.isArray(resp) ? resp : []).map((s) => ({
								key: `village-${s.id}`,
								data: { ...s, name: `${s.code} - ${s.name}`, level: 5, code: s.code },
								children: [],
								leaf: true
							}));
							return { ...n, children };
						}
					}

					if (selectedDemarcation?.id === 2) {
						if (n.data.id === votingDistrictID && n.data.level === 3) {
							const resp = await delimitationService.GetLocalVotingStationByElectorDivisionIDAsync(votingDistrictID);
							const children = (Array.isArray(resp) ? resp : []).map((s) => ({
								key: `polling-centre-${s.id}`,
								data: { ...s, name: `${s.code} - ${s.name}`, level: 4, code: s.code },
								children: [],
								leaf: false
							}));
							return { ...n, children };
						}

						if (n.data.id === registrationCentreID && n.data.level === 4) {
							const resp = await delimitationService.getPollingStationByPollingCentreID(registrationCentreID);
							const children = (Array.isArray(resp) ? resp : []).map((s) => ({
								key: `polling-station-${s.id}`,
								data: { ...s, name: `${s.code} - ${s.name}`, level: 5, code: s.code },
								children: [],
								leaf: true
							}));
							return { ...n, children };
						}
					}

					if (n.children?.length > 0) {
						const children = await updateTree(n.children);
						return { ...n, children };
					}

					return n;
				})
			);
		};

		const newTree = await updateTree(nodes);
		setNodes(newTree);
	};

	const onTreeExpand = async (event) => {
		const node = event.node;
		if (!node || !node.data) return;
		setdermacationForm((prev) => ({
			...prev,
			level: node.data.level
		}));

		if (!node.children || node.children.length === 0) {
			let children = [];
			if (selectedDemarcation?.id === 1) {
				if (node.data.level === 1) children = await fetchConstituencies(node);
				else if (node.data.level === 2) children = await fetchVotingDistricts(node);
				else if (node.data.level === 3) children = await fetchVotingStations(node);
				else if (node.data.level === 4) children = await fetchVillages(node);
			} else if (selectedDemarcation?.id === 2) {
				if (node.data.level === 1) children = await fetchCouncils(node);
				else if (node.data.level === 2) children = await fetchElectoralDivision(node);
				else if (node.data.level === 3) children = await fetchPollingCentre(node);
				else if (node.data.level === 4) children = await fetchPollingStation(node);
			}
			const updateTree = (tree) =>
				tree.map((n) => {
					if (n.key === node.key) return { ...n, children };
					if (n.children && n.children.length > 0) return { ...n, children: updateTree(n.children) };
					return n;
				});

			setNodes((prev) => updateTree(prev));
		}
	};

	const findNodeByKey = (key, tree = nodes) => {
		for (let node of tree) {
			if (node.key === key) return node;
			if (node.children) {
				const found = findNodeByKey(key, node.children);
				if (found) return found;
			}
		}
		return null;
	};

	const openAddDialog = (node = null) => {
		if (!node) return;

		let newForm = { ...dermacationForm };

		if (node.data.level === DermacationLevels.Level3) {
			newForm = {
				...newForm,
				parentID: node.data.id,
				votingDistrictID: node.data.id,
				votingDistrictName: node.data.name,
				registrationCenterNAID: null,
				registrationCenterLGID: null,
				registrationCentreID: null,
				registrationCentreName: "",
				parentCode: node.data?.code || "",
				code: "",
				no: "",
				name: "",
				description: "",
				level: 4,
				status: node.data.status,
				id: null
			};
		} else if (node.data.level === DermacationLevels.Level4) {
			newForm = {
				...newForm,
				registrationCentreID: node.data.id,
				registrationCentreName: node.data.name,
				registrationCenterNAID: selectedDemarcation?.id === 1 ? node.data.id : null,
				registrationCenterLGID: selectedDemarcation?.id === 2 ? node.data.id : null,
				parentCode: node.data?.code || "",
				code: "",
				no: "",
				name: "",
				description: "",
				level: 5,
				status: node.data.status,
				id: null
			};
		} else {
			toast.current.show({
				severity: "warn",
				summary: "Add Restricted",
				detail: "You can only add under Voting District or Registration Centre"
			});
			return;
		}

		setdermacationForm(newForm);
		setTargetNode(node);
		setEditMode(false);
		setNodeName("");
		setDialogVisible(true);
	};

	const openEditDialog = (node) => {
		if (!node) return;
		const parents = findParentChain(node.key, nodes) || [];

		const newForm = {
			...dermacationForm,
			level: node.data.level,
			name: node.data.fullName || "",
			code: node.data.code || "",
			no: node?.data.no ?? node?.data?.localRegistrationCentreNo ?? null,
			description: node.data.description || "",
			id: node?.data?.id,
			status: node?.data?.status
		};

		parents.forEach((p) => {
			switch (p.data.level) {
				case 1:
					newForm.districtID = p.data.id;
					newForm.districtName = p.data.name;
					break;
				case 2:
					newForm.constituencyID = p.data.id;
					newForm.constituencyName = p.data.name;
					break;
				case 3:
					newForm.votingDistrictID = p.data.id;
					newForm.votingDistrictName = p.data.name;
					break;
				case 4:
					newForm.id = p.data.id;
					newForm.code = p.data.code;
					newForm.registrationCentreName = p.data.fullName;
					newForm.registrationCenterNAID = p.data.registrationCenterNAID || null;
					newForm.no = node.data.registrationCentreNo ?? node.data.localRegistrationCentreNo;
					newForm.registrationCenterLGID = p.data.registrationCenterLGID || null;
					break;
				case 5:
					newForm.id = p.data.id;
					newForm.no = node.data.villageNo;
					newForm.code = p.data.code;
					newForm.registrationCentreName = p.data.fullName;
					newForm.registrationCenterNAID = p.data.registrationCenterNAID || null;
					newForm.registrationCenterLGID = p.data.registrationCenterLGID || null;
					break;
			}
		});

		if (node.data.level === 4) {
			newForm.id = node.data.id;
			newForm.code = node.data.code;
			newForm.no = node.data.registrationCentreNo ?? node.data.localRegistrationCentreNo;
			newForm.registrationCentreName = node.data.fullName;
			newForm.registrationCenterNAID = node.data.id;
			newForm.registrationCenterLGID = node.data.registrationCenterLGID || null;
		}
		if (node.data.level === 5) {
			newForm.RegistrationCentreModel =
				selectedDemarcation?.id === 1 ? node.data.localRegistrationCentreModel : node.data.registrationCentreModel;
			newForm.no = node.data.villageNo;
			newForm.id = node.data.id;
			newForm.code = node.data.code
			newForm.registrationCenterNAID = node.data.registrationCenterNAID;
			newForm.registrationCenterLGID = node.data.registrationCenterLGID;
		}
		setdermacationForm(newForm);
		setTargetNode(node);
		setEditMode(true);
		setNodeName(node.data?.fullname || "");
		setDialogVisible(true);
	};

	const openMoveDialog = (node) => {
		if (!node) return;
		const parents = findParentChain(node.key, nodes) || [];
		const newForm = {
			...dermacationForm,
			level: node.data.level,
			name: node.data.name || "",
			code: node.data.code || "",
			no: node.data.no || null,
			description: node.data.description || "",
			id: node?.data?.id,
			status: node?.data?.status
		};
		parents.forEach((p) => {
			switch (p.data.level) {
				case 1:
					newForm.districtID = p.data.id;
					newForm.districtName = p.data.name;
					break;
				case 2:
					newForm.constituencyID = p.data.id;
					newForm.constituencyName = p.data.name;
					break;
				case 3:
					newForm.votingDistrictID = p.data.id;
					newForm.votingDistrictName = p.data.name;
					break;
				case 4:
					newForm.id = p.data.id;
					newForm.registrationCentreName = p.data.name;
					break;
				case 5:
					newForm.id = p.data.id;
					newForm.registrationCentreName = p.data.name;
					break;
			}
		});
		if (node.data.level === DermacationLevels.Level4) {
			newForm.id = node.data.id;
			newForm.registrationCentreName = node.data.name;
			newForm.parentID = node?.data?.parentID;
			newForm.registrationCenterNAID = node?.data?.registrationCenterNAID;
			newForm.parentRegistrationCentreID = selectedDemarcation?.id == 1 ? node?.data?.pollingDivisionID : null;
			newForm.registrationCenterLGID = node?.data?.registrationCenterLGID;
		}
		if (node.data.level === DermacationLevels.Level5) {
			newForm.id = node.data.id;
			newForm.villageName = node.data.name;
			newForm.registrationCenterNAID = node?.data?.registrationCenterNAID;
			newForm.registrationCenterLGID = node?.data?.registrationCenterLGID;

		}

		setdermacationForm(newForm);
		setTargetNode(node);
		setmoveDermacation(true);
		setNodeName(node.data?.name || "");
	};

	const updateNodeData = (tree, nodeId, level, newData) => {
		return tree.map((n) => {
			if (n.data.id === nodeId && n.data.level === level) {
				return { ...n, data: { ...n.data, ...newData } };
			}
			if (n.children && n.children.length > 0) {
				return { ...n, children: updateNodeData(n.children, nodeId, level, newData) };
			}
			return n;
		});
	};

	const removeMovedNode = (tree, movedId) => {
		return tree
			.map((node) => {
				if (node.children?.length) {
					node = { ...node, children: removeMovedNode(node.children, movedId) };
				}
				return node;
			})
			.filter((node) => node.data.id !== movedId);
	};

	const onSave = async () => {
		if (!nodeName?.trim() && !editMode) {
			toast.current.show({
				severity: "warn",
				summary: "Validation",
				detail: "Name cannot be empty."
			});
			return;
		}

		setIsLoading(true);

		const payload = {
			name: dermacationForm.name || nodeName,
			no: dermacationForm.no,
			code: dermacationForm.code || "",
			ParentID: dermacationForm.parentID ?? null,
			DelimitationLevelID: dermacationForm.level,
			registrationCenterNAID: dermacationForm.registrationCenterNAID,
			registrationCenterLGID: dermacationForm.registrationCenterLGID,
			description: dermacationForm.description || "",
			isNationalDemarcation: selectedDemarcation?.id === 1,
			id: dermacationForm.id
		};

		const movePayload = {
			...payload,
			ParentID: dermacationForm.parentRegistrationCentreID ?? null,
			registrationCenterNAID: dermacationForm.level === 5 ? dermacationForm.registrationCenterNAID : null,
			registrationCenterLGID: dermacationForm.level === 5 ? dermacationForm.registrationCenterLGID : null
		};

		try {
			let res;
			if (moveDermacation) {
				res = await delimitationService.move(movePayload);
			} else if (editMode) {
				res = await delimitationService.updateDermacation(payload);
			} else {
				res = await delimitationService.createDermacation(payload);
			}

			setIsLoading(false);

			if (!res) throw new Error("No response from server");

			toast.current.show({
				severity: res.success ? "success" : "error",
				summary: "Message",
				detail: res.message,
				life: 2000
			});

			const updateTreeChildren = async () => {
				if (!targetNode) return [];

				if (dermacationForm.level === DermacationLevels.Level4) {
					return selectedDemarcation?.id === 1 ? await fetchVotingStations(targetNode) : await fetchPollingCentre(targetNode);
				} else if (dermacationForm.level === DermacationLevels.Level5) {
					return selectedDemarcation?.id === 1 ? await fetchVillages(targetNode) : await fetchPollingStation(targetNode);
				}
				return [];
			};

			setIsLoading(false);
			if (moveDermacation && res.success) {
				setNodes((prev) => removeMovedNode(prev, dermacationForm.id));
				resetForm();
				return;
			}

			if (editMode && res.success && targetNode) {
				const updatedName = dermacationForm.name || nodeName;
				const updatedCode = dermacationForm.code || "";
				const updatedNo = dermacationForm.no || null;
				const updatedDesc = dermacationForm.description || "";
				const displayName = updatedCode ? `${updatedCode} - ${updatedName}` : updatedName;

				const updatedData = {
					name: displayName,
					code: updatedCode,
					no: updatedNo,
					description: updatedDesc,
					registrationCenterNAID: selectedDemarcation?.id === 1 ? dermacationForm.registrationCenterNAID || null : undefined,
					registrationCenterLGID: selectedDemarcation?.id !== 1 ? dermacationForm.registrationCenterLGID || null : undefined
				};

				setNodes((prev) => updateNodeData(prev, dermacationForm.id, targetNode.data.level, updatedData));
				setNodeName(displayName);
				resetForm();
				return;
			}

			if (!editMode && res.success && targetNode) {
				setdermacationForm((prev) => ({
					...prev,
					name: "",
					no: null,
					code: "",
					description: ""
				}));
				const children = await updateTreeChildren();
				setNodes((prev) => {
					const updateTree = (tree) =>
						tree.map((n) =>
							n.key === targetNode.key ? { ...n, children } : n.children ? { ...n, children: updateTree(n.children) } : n
						);
					return updateTree(prev);
				});
				resetForm();
			}
		} catch (err) {
			console.error(err);
			setIsLoading(false);
			toast.current.show({
				severity: "error",
				summary: "Error",
				detail: "Technical issue processing your request",
				life: 2000
			});
		}
	};

	const resetForm = () => {
		setDialogVisible(false);
		setEditMode(false);
		setmoveDermacation(false);
		setNodeName("");
		setdermacationForm({
			...dermacationForm,
			name: "",
			no: null,
			code: "",
			description: ""
		});
	};

	const handleDeactivate = (data) => {
		if (!data?.id) return;
		const newStatus = false;

		const payload = {
			id: data.id,
			code: data.code,
			no: data?.no ?? data?.villageNo ?? data?.registrationCentreNo ?? null,
			name: data?.name,
			description: data?.description,
			status: newStatus,
			isNationalDemarcation: selectedDemarcation?.id === 1,
			delimitationLevelID: data.level,
			parentID: data.level === DermacationLevels.Level4 ? data?.pollingDivisionID : null,
			registrationCenterNAID: data.level === DermacationLevels.Level5 ? data?.registrationCenterNAID : null,
			registrationCenterLGID: data.level === DermacationLevels.Level5 ? data?.registrationCenterLGID : null
		};

		confirmDialog({
			message: "Are you sure you want to deactivate this item?",
			header: "Deactivate",
			icon: "pi pi-exclamation-triangle",
			accept: async () => {
				setIsLoading(true);

				try {
					const resp = await delimitationService.deactive(payload);
					setIsLoading(false);

					if (resp?.success) {
						toast.current.show({
							severity: "success",
							summary: "Success",
							detail: resp?.message,
							life: 3000
						});
						setNodes((prev) => updateNodeData(prev, data.id, data.level, { status: newStatus }));
					} else {
						toast.current.show({
							severity: "error",
							summary: "Error",
							detail: resp?.message,
							life: 3000
						});
					}
				} catch (e) {
					setIsLoading(false);
					toast.current.show({
						severity: "error",
						summary: "Error",
						detail: "Technical issue processing your request",
						life: 3000
					});
				}
			},
			reject: () => { }
		});
	};
	const actionTemplate = (node) => {
		const nodeDistrictId = getDistrictIdForNode(node);
		const canActionDermacation = allowedDistrictIds.has(nodeDistrictId);

		return (
			<div className="flex gap-1">
				{node.data.level >= DermacationLevels.Level3 && node.data.level != DermacationLevels.Level5 && (
					<>
						{permission?.actions?.includes(permissionLookUp.Create) && canActionDermacation && (
							<Button
								icon="pi pi-plus"
								rounded
								type="button"
								severity="success"
								onClick={() => {
									openAddDialog(node);
								}}
							/>
						)}
					</>
				)}

				{node.data.level > DermacationLevels.Level3 && canActionDermacation && (
					<>
						{permission?.actions?.includes(permissionLookUp.Delete) && (
							<>
								<Button
									icon="pi pi-pencil"
									type="button"
									tooltip="Edit Demarcation"
									rounded
									severity="info"
									onClick={() => openEditDialog(node)}
								/>

								<Button
									icon="pi pi-arrow-right-arrow-left"
									type="button"
									rounded
									severity="warning"
									tooltip="Move Demarcation"
									onClick={() => openMoveDialog(node)}
								/>
							</>
						)}
						{permission?.actions?.includes(permissionLookUp.Delete) && (
							<Button
								disabled={node.data.level < 3}
								type="button"
								icon="pi pi-times"
								severity="danger"
								rounded
								tooltip="Click Deactivate"
								onClick={() => {
									handleDeactivate(node?.data);
								}}
							/>
						)}
					</>
				)}
			</div>
		);
	};

	let levelNameMapNational;
	if (selectedDemarcation?.id === 1) {
		levelNameMapNational = {
			1: changeLang.get("national_delimitation.district"),
			2: changeLang.get("national_delimitation.constituency"),
			3: changeLang.get("national_delimitation.electoralDivision"),
			4: changeLang.get("national_delimitation.votingCentre"),
			5: changeLang.get("national_delimitation.village")
		};
	} else {
		levelNameMapNational = {
			1: changeLang.get("local_delimitation.district"),
			2: changeLang.get("local_delimitation.council"),
			3: changeLang.get("local_delimitation.electoralDivision"),
			4: changeLang.get("local_delimitation.pollingStation"),
			5: changeLang.get("local_delimitation.village")
		};
	}

	return (
		<div className="card p-4">
			<ConfirmDialog />
			<ScreenLoader visible={isLoading} />
			<Toast ref={toast} />
			<div className="grid mb-3">
				<div className="col-12 ">
					<h3>Select Demarcation type</h3>
					<Dropdown
						value={selectedDemarcation}
						placeholder="Select Demarcation type"
						className="w-full"
						showClear
						options={dermacations}
						optionLabel="name"
						onChange={(e) => {
							const obj = e.value;
							setSelectedDemarcation(obj);
							const id = obj?.id ?? null;
							if (id != null) {
								fetchDistricts(id);
							} else {
								setNodes([]);
							}
						}}
					/>
				</div>
			</div>
			<div
				style={{ minWidth: "900px" }}
			>
				<TreeTable
					value={nodes}
					selectionMode="single"
					selectionKeys={selectedNodeKey}
					tableStyle={{ minWidth: "900px" }}
					resizableColumns
					scrollable
					onSelectionChange={(e) => {
						setSelectedNodeKey(e.value);
						const key = Object.keys(e.value)[0];
						const node = findNodeByKey(key);
						handleSelectNode(node);
					}}
					onExpand={onTreeExpand}
				>
					<Column field="name" header="Name" className="treetable-columns" expander style={{ widows: "350px" }} />
					<Column header="Level" className="treetable-columns" body={(node) => levelNameMapNational[node.data?.level] ?? ""} />
					<Column
						style={{ width: "200px", textAlign: "start" }}
						sortable
						field="isActive"
						header="Status"
						body={(e) => {
							const isActive = e.data.status == true;
							return isActive ? (
								<Button label="Active" className="p-button-success p-button-rounded" style={{ height: "30px" }} />
							) : (
								<Button label="Not Active" className="p-button-danger p-button-rounded" style={{ height: "30px" }} />
							);
						}}
					/>
					<Column header="Actions" body={actionTemplate} />
				</TreeTable>
			</div>
			<AddDermacation
				isNational={selectedDemarcation?.id === 1}
				dermacationForm={dermacationForm}
				setdermacationForm={setdermacationForm}
				showDialog={dialogVisible}
				setDialogVisible={setDialogVisible}
				editMode={editMode}
				nodeName={nodeName}
				setNodeName={setNodeName}
				onSave={onSave}
			/>

			<MoveDelimitations
				moveDermacation={moveDermacation}
				setmoveDermacation={setmoveDermacation}
				dermacationForm={dermacationForm}
				setdermacationForm={setdermacationForm}
				isNational={selectedDemarcation?.id === 1}
				nodeName={nodeName}
				onMove={onSave}
			/>
		</div>
	);
};
